import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import is from 'is_js';

import SettingsPanel from 'components/settings-panel/SettingsPanel';
import SettingsToggle from 'components/settings-panel/SettingsToggle';
import useAsyncCancel from 'hooks/useAsyncCancel';
import useAsyncInterceptors from 'hooks/useAsyncInterceptors';
import useBUState from 'hooks/useBUState';
import useCheckLoginState from 'hooks/useCheckLoginState';
import usePlantState from 'hooks/usePlantState';
import AuthLayout from 'layouts/AuthLayout';
import ErrorLayout from 'layouts/ErrorLayout';
import MainLayout from 'layouts/MainLayout';
import { ROUTER_PATH } from 'types/const';
import useAlarmInfo from 'hooks/useAlarmInfo';

/**
 * 레이아웃
 */
const Layout = () => {
  /* variable */
  const { classList } = document.getElementsByTagName('html')[0];

  /* hook */
  useAsyncInterceptors();
  useAsyncCancel();
  useCheckLoginState();
  useBUState();
  usePlantState();
  useAlarmInfo();

  /* watch */
  useEffect(() => {
    if (is.windows()) {
      classList.add('windows');
    }

    if (is.chrome()) {
      classList.add('chrome');
    }

    if (is.firefox()) {
      classList.add('firefox');
    }
  }, [classList]);

  /* view */
  return (
    <>
      <Switch>
        <Route path={ROUTER_PATH.login} exact component={AuthLayout} />
        <Route path="/errors" component={ErrorLayout} />
        <Route component={MainLayout} />
        <Redirect to="/errors/404" />
      </Switch>
      <SettingsToggle />
      <SettingsPanel />
    </>
  );
};

export default Layout;
